__turbopack_context__.v({
  "appDownloadBadgeText": "MjkGda_appDownloadBadgeText",
  "appDownloadBox": "MjkGda_appDownloadBox",
  "appDownloadLogo": "MjkGda_appDownloadLogo",
  "downloadAppBadges": "MjkGda_downloadAppBadges",
});
